<template>
  <div id="GroupList">
      <div :class="`loader${loaderClass}`" v-show="loading">
      </div>
      <div id="page-content-wrapper" class="admin-content-area">
          <template v-if="cantAccessPage === true">
              <div class="page-name">
                  <div class="page-title"> Customer Order Pricing List</div>
                  <router-link v-if="canAddGroup" class="btn btn-primary pull-right" v-bind:to="{ path:'/customer-order-pricing/create'}" > <i class="fp-add"> </i> Add</router-link>
              </div>
              <div class="container-fluid">
                  <div class="admin-page-content group-list">
                      <data-table-filter-config :moduleName="'coPriceList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                      <section class="data-table bg-white">
                              <custom-pagination
                                  :page-changed="onPageChange"
                                  :per-page-changed="onPerPageChange" :moduleName="'coPriceList'" :position="'top'">
                              </custom-pagination>
                              <vue-good-table
                                  ref="listCustomerOrderPriceTable"
                                  mode="remote"
                                  title="coPrice"
                                  @on-page-change="onPageChange"
                                  @on-selected-rows-change="selectionChanged"
                                  @on-column-filter="onColumnFilter"
                                  @on-per-page-change="onPerPageChange"
                                  @on-sort-change="onSortChange"
                                  :totalRows="totalRecords"
                                  :columns="userColumns"
                                  :rows="rows"
                                  :pagination-options="{
                                      enabled: false,
                                      position: 'both',
                                      perPage: perPage,
                                      perPageDropdown:dropDownPerPage,
                                      dropdownAllowAll: false,
                                  }"
                                  :select-options="{
                                  enabled: group_value,
                                  selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                  selectionInfoClass: 'custom-class',
                                  selectionText: 'rows selected',
                                  clearSelectionText: 'clear',
                                  }"
                                  :search-options="{
                                  enabled: false,
                                  }">

                                  <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                      <div :key="key">
                                          <div v-if="props.column.field == 'action'">
                                              <router-link title="Edit customer order pricing" v-if="canUpdateGroup" class="fp-edit" v-bind:to="{name: 'CustomerOrderPricingEdit',params:{id:props.row.id}}"></router-link>
                                          </div>
                                          <div v-else>
                                              {{props.formattedRow[props.column.field]}}
                                          </div>
                                      </div>
                                  </template>

                                  <div slot="selected-row-actions">
                                      <button v-if="group_value" id="deleteGroupBtn" v-on:click.prevent="PriceDelete" class="btn btn-danger">Delete</button>
                                  </div>
                              </vue-good-table>
                              <custom-pagination
                                  :page-changed="onPageChange"
                                  :per-page-changed="onPerPageChange">
                              </custom-pagination>
                      </section>
                  </div>
              </div>
          </template>
          <template v-else-if="cantAccessPage === false">
              <div class="container-fluid">
                  <div class="bg-white text-center">
                      <h1>
                          Oops!</h1>
                      <h2>
                          403 </h2>
                      <div class="error-details">
                          Sorry!, You don't have permission to access this page.
                      </div>
                  </div>
              </div>
          </template>
          <template v-else>
              <loading-content></loading-content>
          </template>
          <app-footer></app-footer>
      </div>
  </div>
</template>
<script>

import Vue from "vue";

import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);

import 'vue-good-table/dist/vue-good-table.css';
import VueGoodTable from 'vue-good-table';
Vue.use(VueGoodTable);

import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

  export default {
      name: "CustomerOrderPricingList",
      components: {
          customPagination: () => import('@/components/layout/CustomPagination'),
          dataTableFilterConfig: () => import('@/components/DataTableFilterConfig'),
          appFooter: () => import('@/components/Footer'),
      },
      metaInfo() {
          return {title: "Customer Order Pricing List | " +process.env.COPYRIGHT_NAME}
      },
      mixins:[commonMixins,dataTableMixins],
      data: () => ({
          firstLoad: 0,
           permissions: [],
          cantAccessPage: "",
          userColumns:[],
          columns: [
              {
                  label: 'Actions',
                  field: 'action',
                  sortable: false,
                  hidden:false,
              },
              {
                  label: 'Price Type',
                  field: 'type',
                  filterable: true,
                  fpFieldType:"text",
                  hidden:false,
                  filterOptions: {
                      enabled: false, // enable filter for this column
                      placeholder: "Price Type", // placeholder for filter input
                      filterValue: '', // initial populated value for this filter
                      trigger: "enter" //only trigger on enter not on keyup
                  }
              },
              {
                  label: 'Price',
                  field: 'price',
                  filterable: true,
                  hidden:false,
                  fpFieldType:"integer",
                  filterOptions: {
                      enabled: false, // enable filter for this column
                      placeholder: "Price", // placeholder for filter input
                      filterValue: '', // initial populated value for this filter
                      trigger: "enter" //only trigger on enter not on keyup
                  }
              },
              {
                  label: 'Name',
                  field: 'name',
                  filterable: true,
                  hidden:false,
                  fpFieldType:"text",
                  filterOptions: {
                      enabled: false, // enable filter for this column
                      placeholder: "Name", // placeholder for filter input
                      filterValue: '', // initial populated value for this filter
                      trigger: "enter" //only trigger on enter not on keyup
                  }
              },
          ],
          rows: [],
          totalRecords: 0,
          group_value: false,
          loading:false,
          canUpdateGroup:false,
          canAddGroup:false,
      }),
      created: function() {

      },
      watch:{
          //check permission change
          permissions: function (permissions) {
              var self = this;
              if (permissions.length > 0) {
                  for (var i = 0; i < permissions.length; i++) {
                      if (permissions[i].name == 'list_customer_order_price') {
                          self.cantAccessPage = true;
                      }
                      if (permissions[i].name == 'delete_customer_order_price') {
                          self.group_value = true;
                      }
                      if (permissions[i].name == 'add_customer_order_price') {
                          self.canAddGroup = true;
                          self.canUpdateGroup = true;
                      }
                  }
              }

          }
      },
      mounted: function() {
          var self = this;

          //self.loadList();
          self.getPermissions();
      },
      methods: {
          cancelAll: function (cancelAll) {
            this.$refs.listCustomerOrderPriceTable.unselectAllInternal();
          },
          selectionChanged(param) {
              var self = this;
              if(param.selectedRows.length == 100) {
                EventBus.$emit('clear-selection', false);
              } else {
                EventBus.$emit('clear-all-flags', false);
              }
          },
          loadList() {
              var self = this;
              self.loading = true;
              var fields = {
                  page: self.serverParams.page,
                  perPage: self.serverParams.perPage,
                  filters: self.serverParams.columnFilters,
                  sort: self.serverParams.sort,
              };
              self.firstLoad = 1;
              $.ajax({
                  url: process.env.ROOT_API + "/customer-order-prices/list",
                  type: "POST",
                  data: fields,
                  headers: {
                      Accept: "application/json",
                      "Access-Control-Allow-Origin": "*",
                      "Authorization": "Bearer " + localStorage.getItem("tkn"),
                      "Access-Control-Allow-Headers":
                          "Origin, Content-Type, Authorization,X-Requested-With",
                      "Cache-Control": "no-cache"
                  },
                  dataType: "json",
                  success: function (data) {
                      self.loading = false;
                      // console.log(data);
                      if (data.status == "success") {
                          self.rows = data.content.row;
                          self.totalRecords = data.content.totalRecords;
                          self.filteredFlag = false;
                      }
                  },
                  error: function (jqXHR, exception) {
                      self.loading = false;
                      self.generateStatusCodeMessage(jqXHR,false,'customer-order-price-list')
                  }
              });
          },
          PriceDelete() {
              var self = this;
              self.$swal({
                  title: 'Are you sure that you want to delete this Price?',
                  type: 'info',
                  showCancelButton: true,
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No',
                  showCloseButton: false,
                  showLoaderOnConfirm: true
              }).then((result) => {
                  if (result.value) {
                    var data = this.$refs['listCustomerOrderPriceTable'].selectedRows;
                    var use = [];
                    for (var i = 0; i < data.length; i++) {
                        use.push(this.$refs['listCustomerOrderPriceTable'].selectedRows[i].id)
                    }
                    console.log("list of IDS =", use);
                    self.loading = true;
                    $("#deleteGroupBtn").val("Deleting ...");
                    $.ajax({
                        url: process.env.ROOT_API + "/customer-order-pricing/delete",
                        type: "POST",
                        data: 'id=' + use,
                        headers: {
                            'Accept': 'application/json',
                            "Access-Control-Allow-Origin": '*',
                            "Authorization": "Bearer " + localStorage.getItem("tkn"),
                            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                            "Cache-Control": "no-cache"
                        },
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                            $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);
                            setTimeout(function () {
                                $("#deleteGroupBtn").val("Delete");
                            }, 10000);
                            self.rows = data.content.row;
                            if (data.code == '200') {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'group-delete')
                        }
                    });

                  } else {
                    console.log("no");
                  }
              });
          }
      }
  };
</script>




// WEBPACK FOOTER //
// src/components/asset/CustomerOrderPricingList.vue